import {
  LoomSpaceAriResourceOwner,
  LoomSpaceAriResourceType
} from "./chunk-PZ4WNDYC.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/loom/space/manifest.ts
var loomSpaceAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: LoomSpaceAriResourceOwner,
  resourceType: LoomSpaceAriResourceType,
  resourceIdSlug: "activation/{activationId}/{spaceId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    spaceId: /(?:[0-9]+|[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/
    // eslint-disable-line no-useless-escape
  }
};

// src/loom/space/index.ts
var LoomSpaceAri = class _LoomSpaceAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._spaceId = opts.resourceIdSegmentValues.spaceId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get spaceId() {
    return this._spaceId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: loomSpaceAriStaticOpts.qualifier,
      platformQualifier: loomSpaceAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: loomSpaceAriStaticOpts.resourceOwner,
      resourceType: loomSpaceAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.spaceId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        spaceId: opts.spaceId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, loomSpaceAriStaticOpts);
    return new _LoomSpaceAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, loomSpaceAriStaticOpts);
    return new _LoomSpaceAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      spaceId: this.spaceId
    };
  }
};

export {
  LoomSpaceAri
};
